import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const ViewSwitcherMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewSwitcherMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprisesAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"idPremOrgsAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ViewSwitcherMember","document":ViewSwitcherMemberDocument}} as const;
export type ViewSwitcherMemberQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type ViewSwitcherMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'idEnterprisesAdmin' | 'idPremOrgsAdmin' | 'memberType'>
  )> }
);

/**
 * __useViewSwitcherMemberQuery__
 *
 * To run a query within a React component, call `useViewSwitcherMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSwitcherMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSwitcherMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useViewSwitcherMemberQuery(
  baseOptions: TrelloQueryHookOptions<
    ViewSwitcherMemberQuery,
    ViewSwitcherMemberQueryVariables
  > &
    (
      | { variables: ViewSwitcherMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: ViewSwitcherMemberDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    ViewSwitcherMemberQuery,
    ViewSwitcherMemberQueryVariables
  >(ViewSwitcherMemberDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useViewSwitcherMemberLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    ViewSwitcherMemberQuery,
    ViewSwitcherMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ViewSwitcherMemberQuery,
    ViewSwitcherMemberQueryVariables
  >(ViewSwitcherMemberDocument, options);
}
export function useViewSwitcherMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        ViewSwitcherMemberQuery,
        ViewSwitcherMemberQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ViewSwitcherMemberQuery,
    ViewSwitcherMemberQueryVariables
  >(ViewSwitcherMemberDocument, options);
}
export type ViewSwitcherMemberQueryHookResult = ReturnType<
  typeof useViewSwitcherMemberQuery
>;
export type ViewSwitcherMemberLazyQueryHookResult = ReturnType<
  typeof useViewSwitcherMemberLazyQuery
>;
export type ViewSwitcherMemberSuspenseQueryHookResult = ReturnType<
  typeof useViewSwitcherMemberSuspenseQuery
>;
export type ViewSwitcherMemberQueryResult = Apollo.QueryResult<
  ViewSwitcherMemberQuery,
  ViewSwitcherMemberQueryVariables
>;
